import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { BetslipError } from '../../../errors/betslip-error';
import { UndoCashOutFailedError } from '../../../errors/edit-bet/undo-cash-out-failed-error';
import { MessageFormatter } from './message-formatter';

@Injectable()
export class UndoCashoutFailedErrorMessageFormatter extends MessageFormatter<UndoCashOutFailedError> {
    format(_error: UndoCashOutFailedError): Observable<null> {
        return of(null);
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof UndoCashOutFailedError;
    }
}
